import { createMuiTheme } from "@material-ui/core";

import overrides from "./overrides";
import typography from "./typography";
import palette from "./palette";

const theme = createMuiTheme({
  palette,
  typography,
  overrides,
  zIndex: {
    appBar: 1200,
    drawer: 1100
  }
});

export default theme;
